import React, { useEffect, useState } from "react";
import { Form, Input, Button, DatePicker, Select, Row, Col, message } from "antd";
import axios from "axios";
import moment from "moment";

const { Option } = Select;

const ReservationForm = ({ formData, setFormData, closeModal, refetchData }) => {
  const [form] = Form.useForm();
  const [passengers, setPassengers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [agreements, setAgreements] = useState([]); // State for agreements

  useEffect(() => {
    fetchFormData();
    if (formData) {
      form.setFieldsValue({
        ...formData,
        startDate: formData.startDate ? moment(formData.startDate) : null,
        endDate: formData.endDate ? moment(formData.endDate) : null,
        status: formData.status || "pending",
      });
    }
  }, [formData]);

  const fetchFormData = async () => {
    try {
      const passengersResponse = await axios.get("http://93.127.203.113:5005/passengers");
      const vehiclesResponse = await axios.get("http://93.127.203.113:5005/vehicles");
      const agreementsResponse = await axios.get("http://93.127.203.113:5005/customer-agreements");

      setPassengers(passengersResponse.data);
      setVehicles(vehiclesResponse.data);
      setAgreements(agreementsResponse.data);
    } catch (error) {
      message.error("Failed to fetch form data.");
    }
  };

  const onFinish = async (values) => {
    try {
      const payload = {
        ...values,
        startDate: values.startDate.format("YYYY-MM-DD"),
        endDate: values.endDate ? values.endDate.format("YYYY-MM-DD") : null,
        status: values.status || "pending",
      };
      if (formData?.reservationId) {
        // Update existing reservation
        await axios.put(
          `http://93.127.203.113:5005/reservations/${formData.reservationId}`,
          payload
        );
        message.success("Reservation updated successfully");
      } else {
        // Create a new reservation
        await axios.post("http://93.127.203.113:5005/reservations", payload);
        message.success("Reservation created successfully");
      }
      refetchData();
      closeModal();
    } catch (error) {
      console.error("Error:", error);
      message.error("Failed to save reservation.");
    }
  };

  return (
    <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "30px" }}>
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
        style={{
          padding: "40px",
          border: "1px solid #0c8c49",
          borderRadius: "10px",
          backgroundColor: "#ffffff",
          boxShadow: "0 6px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Row gutter={[32, 32]}>
          <Col span={12}>
            <Form.Item
              label={<span style={{ color: "black", fontWeight: "normal" }}>Passenger</span>}
              name="passengerId"
              rules={[{ required: true, message: "Please select a passenger" }]}
            >
              <Select placeholder="Select a passenger" style={{ borderColor: "#0c8c49" }}>
                {passengers.map((passenger) => (
                  <Option key={passenger.id} value={passenger.id}>
                    {`${passenger.firstName} ${passenger.lastName}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={<span style={{ color: "black", fontWeight: "normal" }}>Vehicle</span>}
              name="vehicleId"
              rules={[{ required: true, message: "Please select a vehicle" }]}
            >
              <Select placeholder="Select a vehicle" style={{ borderColor: "#0c8c49" }}>
                {vehicles.map((vehicle) => (
                  <Option key={vehicle.id} value={vehicle.id}>
                    {`${vehicle.plateNumber} (${vehicle.model})`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[32, 32]}>
          <Col span={12}>
            <Form.Item
              label={<span style={{ color: "black", fontWeight: "normal" }}>Agreement</span>}
              name="agreementId"
              rules={[{ required: true, message: "Please select an agreement" }]}
            >
              <Select placeholder="Select an agreement" style={{ borderColor: "#0c8c49" }}>
                {agreements.map((agreement) => (
                  <Option key={agreement.agreementId} value={agreement.agreementId}>
                    {`Agreement #${agreement.agreementId} (${agreement.passenger.firstName} ${agreement.passenger.lastName})`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={<span style={{ color: "black", fontWeight: "normal" }}>Price</span>}
              name="price"
              rules={[{ required: true, message: "Please enter the price" }]}
            >
              <Input type="number" placeholder="Enter price" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[32, 32]}>
          <Col span={12}>
            <Form.Item
              label={<span style={{ color: "black", fontWeight: "normal" }}>Status</span>}
              name="status"
              initialValue="pending"
              rules={[{ required: true, message: "Please select the reservation status" }]}
            >
              <Select style={{ borderColor: "#0c8c49" }}>
                <Option value="pending">Pending</Option>
                <Option value="confirmed">Confirmed</Option>
                <Option value="cancelled">Cancelled</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={<span style={{ color: "black", fontWeight: "normal" }}>Start Date</span>}
              name="startDate"
              rules={[{ required: true, message: "Please select the start date" }]}
            >
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[32, 32]}>
          <Col span={12}>
            <Form.Item
              label={<span style={{ color: "black", fontWeight: "normal" }}>End Date</span>}
              name="endDate"
            >
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="end">
          <Col>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                backgroundColor: "#0c8c49",
                borderColor: "#0c8c49",
                marginRight: "10px",
              }}
            >
              Save
            </Button>
            <Button
              htmlType="button"
              onClick={() => form.resetFields()}
              style={{
                borderColor: "#0c8c49",
                color: "#0c8c49",
              }}
            >
              Reset
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ReservationForm;
